import flow from 'lodash/flow'
import { parseJSON, formatWithOptions } from 'date-fns/fp'
import ru from 'date-fns/locale/ru'

export const formatTime = flow(
  parseJSON,
  formatWithOptions({ locale: ru }, 'PP')
)
